/**
 * Router-shell da página do COLABORADOR de Solicitações (Suprimentos).
 * Montar em <Route path="/suprimentos/solicitacoes/*" element={<SolicitacoesColaborador />} />.
 *
 * Sub-rotas:
 *   /                       -> Hub (5 tipos + minhas solicitações)
 *   /criar/:tipo            -> formulário (asm|ast|asp -> assistência; rqa|rqi -> requisição)
 *   /comprovante            -> tela de sucesso com JPG compartilhável (via state de navegação)
 *   /rqc/novo | /rqc/:id    -> RQC do escritorio (vira Requisicao de Compra; ADR-0074)
 *   /:familia/:id           -> detalhe somente-consulta (assistencia|requisicao)
 *
 * A página de GESTÃO (autorizar/atender/lotes) é outra superfície — aqui não
 * existe nenhum botão de autorização.
 */
import React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";

import Comprovante from "./Comprovante";
import CriarAssistencia from "./CriarAssistencia";
import CriarRequisicao from "./CriarRequisicao";
import CriarRqc from "./CriarRqc";
import Detalhe from "./Detalhe";
import Hub from "./Hub";
import RqcDetalhe from "./RqcDetalhe";
import { tipoPorValor } from "./utils";

function Criar() {
  const { tipo } = useParams();
  const tipoInfo = tipoPorValor(String(tipo || "").toUpperCase());
  if (!tipoInfo) return <Navigate to=".." replace />;
  if (tipoInfo.familia === "requisicao") {
    return <CriarRequisicao key={tipoInfo.value} tipoInfo={tipoInfo} />;
  }
  return <CriarAssistencia key={tipoInfo.value} tipoInfo={tipoInfo} />;
}

export default function SolicitacoesColaborador() {
  return (
    <Routes>
      <Route index element={<Hub />} />
      <Route path="criar/:tipo" element={<Criar />} />
      {/* RQC (ADR-0074): cria uma Requisicao de Compra, nao uma solicitacao interna. */}
      <Route path="rqc/novo" element={<CriarRqc />} />
      <Route path="rqc/:id" element={<RqcDetalhe />} />
      <Route path="comprovante" element={<Comprovante />} />
      <Route path=":familia/:id" element={<Detalhe />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
